import { CardGiftcardOutlined, HistoryOutlined, PreviewOutlined } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import { variants } from '../../../../variants/variants';
import { useDispatch } from 'react-redux';
import { setPreview, setShowHistory } from '../../giftSlice';

const ManagerNavbar = ({ history = true }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const activePath = pathname.split('/')[3];
  const theme = useTheme();
  const dispatch = useDispatch();
  const value = pathname.split('/gift/')[1]?.split('/')[0];
  const handleHistoryClick = () => {
    dispatch(setShowHistory({ value }));
    dispatch(setPreview({ reset: true }));
  };
  return (
    <Stack direction={'row'} sx={{ width: 1 }}>
      <CardGiftcardOutlined sx={variants.icon.active} />
      <Typography component='div' sx={{ ml: 1, fontSize: variants.BODY, fontWeight: 700 }}>
        GIFT
        <Typography sx={{ fontSize: variants.TINY }}>Gateway Internal Fast Track Program</Typography>
      </Typography>
      {history && (
        <Stack
          sx={{
            ml: 'auto',
            cursor: 'default',
            // [theme.breakpoints.up('lg')]: {
            //   display: 'none',
            // },
          }}
          onClick={handleHistoryClick}
        >
          <IconButton sx={{ m: 'auto', p: 0 }}>
            <HistoryOutlined />
          </IconButton>
          <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main }}>History</Typography>
        </Stack>
      )}
      {/* 
      <Stack
        sx={{
          ml: 'auto',
          cursor: 'default',
          [theme.breakpoints.up('lg')]: { display: 'none' },
          ml: 'auto',
        }}
        onClick={handleOpenPreview}
      >
        <IconButton sx={{ m: 'auto', p: 0 }}>
          <PreviewOutlined />
        </IconButton>
        <Typography sx={{ fontSize: variants.BODY, color: variants.typography.active.main }}>Preview</Typography>
      </Stack> */}
    </Stack>
  );
};

export default ManagerNavbar;
